import {
  SET_PAGE,
  SET_COUNTRY,
  SAVE_SESSION,
  RENEW_SESSION,
  DELETE_SESSION,
  SAVE_SESSION_DUMMY,
  UPDATE_COMPANY_NAME,
  SAVE_SESSION_REGISTER,
} from "../constants/constants";
import { customDecode } from "../../components/utils/functions";

const initialSessionState = {
  sessionInfo: {
    authenticated: false,
    session: "",
    userType: "",
    countryCode: "",
    roles: {},
  },
  registerInfo: { authenticated: false, session: "", register: "" },
  userInfo: { session: "" },
  page: "",
};

export default (state = initialSessionState, action) => {
  switch (action.type) {
    case SAVE_SESSION:
      return {
        ...state,
        sessionInfo: {
          authenticated: true,
          session: action.payload.session.opaque,
          userType: action.payload.userType,
          username: action.payload.username,
          expiration: customDecode(action.payload.session.jwt)?.iat,
          lastSession:
            customDecode(action.payload.session.jwt)?.last_session !== undefined
              ? customDecode(action.payload.session.jwt)?.last_session
              : null,
          firstName:
            action.payload.session.firstName !== null
              ? action.payload.session.firstName
              : "",
          lastName:
            action.payload.session.lastName !== null
              ? action.payload.session.lastName
              : "",
          institutionName: action.payload.session.institutionName,
          countryCode: action.payload.countryCode,
          roles: action.payload.roles,
          institutionId: customDecode(action.payload.session.jwt)
            ?.institution_id,
          clientId: action.payload?.clientId,
          mainInstitution: customDecode(action.payload.session.jwt)
            ?.institution_id,
          allCompanies: false,
        },
      };
    case SAVE_SESSION_REGISTER:
      return {
        ...state,
        registerInfo: {
          authenticated: true,
          session: action.payload.register.jwt,
          email: action.payload.register.email,
          id: action.payload.register.id,
          code: action.payload.register.code,
          firstName: action.payload.register.firstName,
          lastName: action.payload.register.lastName,
          institutionName: action.payload.register.institutionName,
          authCode: action.payload.userData?.authCode,
          refCode: action.payload.userData?.refCode,
        },
      };
    case SAVE_SESSION_DUMMY:
      return {
        ...state,
        userInfo: {
          session: action.payload.validateUser.jwt,
        },
      };
    case DELETE_SESSION:
      return {
        ...state,
        sessionInfo: {
          ...initialSessionState.sessionInfo,
          countryCode: action.payload ? state.sessionInfo.countryCode : "",
        },
      };
    case RENEW_SESSION:
      return {
        ...state,
        sessionInfo: {
          ...state.sessionInfo,
          session: action.payload.opaque,
          expiration: customDecode(action.payload.jwt)?.iat,
        },
      };
    case SET_PAGE:
      return {
        ...state,
        page: action.page,
      };
    case SET_COUNTRY:
      return {
        ...state,
        sessionInfo: {
          countryCode: action.country,
        },
      };
    case UPDATE_COMPANY_NAME:
      return {
        ...state,
        sessionInfo: {
          ...state.sessionInfo,
          institutionName: action.company.name,
          institutionId: action.company.id,
          allCompanies: action.company.allCompanies,
        },
      };
    default:
      return state;
  }
};

export const getSessionCountry = (state) =>
  state.sessionInfoReducer.sessionInfo.countryCode;
export const getSessionToken = (state) =>
  state.sessionInfoReducer.sessionInfo.session;
export const getRegisterInfo = (state) => state.sessionInfoReducer.registerInfo;
export const getDummySessionInfo = (state) => state.sessionInfoReducer.userInfo;
export const getSessionInfo = (state) => state.sessionInfoReducer.sessionInfo;
export const getRoles = (state) => state.sessionInfoReducer.sessionInfo.roles;
export const getPage = (state) => state.sessionInfoReducer.page;
